import { coreApi } from "./CoreAPI";

interface Roles {
    roles: string[];
    permissions: string[];
}

class UserAuthorization {
    private static instance: UserAuthorization;
    private storageKey: string = "user.roles";

    private constructor() { }

    static getInstance(): UserAuthorization {
        if (!UserAuthorization.instance) {
            UserAuthorization.instance = new UserAuthorization();
        }
        return UserAuthorization.instance;
    }

    /**
     * Fetches user roles from the backend server and sets the JSON data in sessionStorage
     */
    async fetchUserRoles(): Promise<void> {
        const response = await coreApi.get<Roles>("/users/me/roles");

        try {
            sessionStorage.setItem(this.storageKey, JSON.stringify(response.data));
        } catch (error) {
            console.log("[Authorization]: " + error);
        }
    }

    /**
     * Checks to see if the user's roles matches the required role for each view or component
     * @param requiredRoles - the array to hold the roles required to view this section
     * @param anyRole - default is true, matches any role in requiredRoles. Set to false to require all the roles
     * @returns boolean
     */
    hasRequiredRoles(requiredRoles: string[], anyRole: boolean = true): boolean {
        try {
            const stored = sessionStorage.getItem(this.storageKey);
            if (!stored) return false;

            const { roles } = JSON.parse(stored) as Roles;
            if (!Array.isArray(roles)) return false;

            if (roles.includes("Admin")) return true;

            if (anyRole)
                return requiredRoles.some(role => roles.includes(role));

            return requiredRoles.every(role => roles.includes(role));
        } catch (error) {
            console.error("[Authorization]: Role check failed:", error);
            return false;
        }
    }
}

export const userAuth = UserAuthorization.getInstance();